const TestimonialCards = (props) => {
  return (
    <div className="p-10 border-2 border-accent rounded-xl grid grid-rows-2">
      <div className="flex justify-center items-center">
        <img
          src={props.imgsrc}
          alt="clients"
          height="100px"
          width="100px"
          className="rounded-full overflow-hidden"
        />
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex justify-center items-center h-fit">
          <span className="fa fa-star checked"></span>
          <span className="fa fa-star checked"></span>
          <span className="fa fa-star checked"></span>
          <span className="fa fa-star checked"></span>
          <span className="fa fa-star"></span>
        </div>
        <h1 className="font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-accent via-[#1C8D8E] to-[#2A5E6F]">
          {props.name}
        </h1>
        <p className="text-center">{props.text}</p>
      </div>
    </div>
  );
};

export default TestimonialCards;
